module.exports = __webpack_public_path__ + "83c3edc5fe3d8c8dbe772235e695791d.png";